export default {"src":"/_next/static/media/Bitcoin.06716d4f.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};